import React, {Fragment, useEffect, useRef, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import functions from "../../../utils/functionsFirebase";
import {CustomModal, InputSaveEdit, Spinner, TitlePage} from "../../shared";
import './groupDetails.css'
import {FormattedMessage, useIntl} from "react-intl";
import auth from "../../../utils/authentication";
import {
    ACCEPT_USERS,
    DELETE_POSTS,
    GROUP_HIDDEN,
    GROUP_PRIVATE,
    GROUP_PUBLIC,
    MANAGE_TAGS,
    MODIFY_INFO,
    TAG_OWN_FILES
} from "../../../utils/consts";
import {useDispatch, useSelector} from "react-redux";
import groupIndex from "../index"
import groups, {GroupForm} from "../index"
import {Helmet} from "react-helmet";
import MonkeyNotFound from "../../shared/monkeyNotFound";
import GroupMenu from "./groupMenu/groupMenu";
import GroupPost from "../../shared/groupPost/groupPost";
import {checkUserGroupRole, getGroupPhotoUrl, isMobileDevice, normalize} from "../../../utils/utils";
import database from "../../../utils/databaseFirebase";
import {OverlayTrigger, Popover} from "react-bootstrap";
import useOutsideClick from "../../../utils/useOutsideClick";
import users, {LoginHome} from "../../users";
import ButtonMenu from "../../app/buttonMenu/buttonMenu";
import app from "../../app";
import {toast} from "react-toastify";

function GroupDetails() {

    const intl = useIntl();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const postsPerPage = 10;

    const {id} = useParams();
    const [group, setGroup] = useState(null);
    const [askedUsers, setAskedUsers] = useState([]);
    const [textSearch, setTextSearch] = useState("");
    const [showingSummary, setShowingSummary] = useState(false);
    const [editing, setEditing] = useState(false);
    const [userRoles, setUserRoles] = useState([]);
    const [roles, setRoles] = useState([]);
    const [loadingLeave, setLoadingLeave] = useState(false);
    const [tags, setTags] = useState([]);

    const [loading, setLoading] = useState(false);

    const [postsPage, setPostsPage] = useState(1);

    const [selectedPost, setSelectedPost] = useState(null);
    const [popoverOpen, setPopoverOpen] = useState(false);
    const [activeButton, setActiveButton] = useState(null);
    const [tagSearch, setTagSearch] = useState("");
    const [selectedTag, setSelectedTag] = useState(null);
    const [hideOptions, setHideOptions] = useState(false);
    let previousScrollTop;

    const saveButtonForm = useRef();
    const closeMenuModal = useRef();

    const darkMode = useSelector(users.selectors.isDarkMode)

    const userGroups = useSelector(groupIndex.selectors.userGroups);
    const files = useSelector(app.selectors.getGroupPosts)[id];

    const [startLoad, setStartLoad] = useState(true);

    const [navWidth, setNavWidth] = useState(0);
    const loginHome = useRef();
    let groupContainer = document.getElementById('groupDetailsContainer');
    const loadedGroup = useSelector(groupIndex.selectors.userGroups)?.groups.find(x => x.id === id);

    useEffect(() => {
        setGroup(prevGroup => {
            return {...loadedGroup};
        });
    }, [loadedGroup?.tags?.length]);

    useEffect(() => {
        const handleResize = () => {
            groupContainer = document.getElementById('groupDetailsContainer');
            if (groupContainer) {
                setNavWidth(groupContainer.clientWidth);
            }
        };
        window.addEventListener('resize', handleResize)
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [groupContainer])

    function getGroupContainerWidth() {
        groupContainer = document.getElementById('groupDetailsContainer');
        if (groupContainer) {
            return groupContainer.clientWidth;
        }
        return null;
    }

    function loadGroup() {
        const getGroup = functions.httpsCallable('getGroup');
        getGroup({groupId: id}).then(res => {
            setGroup(loadedGroup ?? res.data.group);
            // dispatch(groupIndex.actions.updateLoadedGroup(res.data.group));
            setShowingSummary(false);
            setLoading(false);
            setAskedUsers(res.data.group.askJoinUsers.map(x => {
                return {uid: x, loading: false}
            }))
        }).catch(error => {
            if (error.toString().includes('unauthenticated')) {
                const getGroupSummary = functions.httpsCallable('getGroupSummary');
                getGroupSummary({groupId: id}).then(res => {
                    setGroup(res.data.group);
                    setAskedUsers([]);
                    setShowingSummary(true);
                    setLoading(false);
                })

            } else if (error.toString().includes("not-found")) {
                setGroup({});
                setLoading(false);
            }
        })
    }

    useEffect(() => {
        if (group?.id && !showingSummary) {
            if (auth.currentUser) {
                const groupUserRef = database.ref(`/group-users/${group.refId}/roles`);
                // Set up a listener for changes
                groupUserRef.on('child_added', snapshot => {
                    const roleId = snapshot.val();
                    setUserRoles(prevState => {
                        const aux = [...prevState];
                        aux.push(roleId);
                        return [...new Set(aux)];
                    })
                });
                groupUserRef.on('child_removed', snapshot => {
                    const roleId = snapshot.val();
                    setUserRoles(prevState => {
                        if (prevState.some(x => x === roleId)) {
                            return prevState;
                        }
                        const aux = [...prevState];
                        const index = aux.findIndex(x => x === roleId);
                        aux.splice(index, 1);
                        return aux;
                    })
                });

                return () => {
                    groupUserRef.off('child_added');
                    groupUserRef.off('child_removed');
                }
            }
            const groupFileRef = database.ref('/groupFile/')
                .orderByChild('groupId')
                .equalTo(group.id);

            dispatch(app.actions.addGroup({groupId: id, posts: []}));
            // Set up a listener for changes
            groupFileRef.on('child_added', snapshot => {
                const newFile = snapshot.val();
                newFile.id = snapshot.key;
                newFile.file.uploadDate = new Date(newFile.file.uploadDate);
                dispatch(app.actions.addPost(newFile));
            });
            groupFileRef.on('child_changed', snapshot => {
                const newFile = snapshot.val();
                newFile.id = snapshot.key;
                dispatch(app.actions.modifyPost(newFile));
            });
            groupFileRef.on('child_removed', snapshot => {
                const newFile = snapshot.val();
                newFile.id = snapshot.key;
                dispatch(app.actions.removePost(newFile));
            });

            return () => {
                groupFileRef.off('child_added')
                groupFileRef.off('child_changed');
                groupFileRef.off('child_removed');
            }

        }

    }, [group?.id, showingSummary]);

    useEffect(() => {
        setLoading(true);
        loadGroup();
    }, [id]);

    const handleScroll = (e) => {
        const visorElement = document.getElementById('visor');
        if (visorElement) {
            const rect = visorElement.getBoundingClientRect();
            if (postsPage * postsPerPage <= files.length) {
                if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                    setPostsPage(prevValue => prevValue + 1);
                }
            }
            const currentScrollTop = e.target.scrollTop;
            if (currentScrollTop + (isMobileDevice() ? 20 : 0) < previousScrollTop || currentScrollTop == 0) {
                setHideOptions(false);
            } else if (currentScrollTop - (isMobileDevice() ? 4 : 0) > previousScrollTop) {
                setHideOptions(true);
            }
            previousScrollTop = currentScrollTop;
        }
    };

    useEffect(() => {
        const scrollContainer = document.getElementById('home__scrollContainer');
        scrollContainer.removeEventListener('scroll', handleScroll);
        scrollContainer.addEventListener('scroll', handleScroll);
        return () => {
            scrollContainer.removeEventListener('scroll', handleScroll);
        };
    }, [files?.length]);


    const openPopover = (user, event) => {
        setSelectedPost(user)
        setTagSearch("");
        setPopoverOpen(true);
        setActiveButton(event.target.id);
    };

    const closePopover = () => {
        setSelectedPost(null);
        setPopoverOpen(false);
        setActiveButton(null);
    };

    async function addTagToPost(post, tag) {
        if (!post) {
            closePopover();
            return;
        }
        if (post.loadingAddTag) {
            return;
        }
        closePopover();

        const index = files.findIndex(x => x.id === post.id);
        files[index].loadingAddTag = true;

        const toggleTag = functions.httpsCallable('toggleTag');
        await toggleTag({postId: post.id, tagId: tag.id, groupId: group.id});

    }

    // Use the custom hook to handle clicks outside the popover
    useOutsideClick("popover-tags", closePopover);

    if (!group || (!group.groupName && loading)) {
        return (
            <div>
                <TitlePage icon=""
                           leftClass="col-12"
                           title={
                               <div>
                               </div>
                           }/>
                <div className="d-flex flex-row justify-content-center">
                    <Spinner/>
                </div>
            </div>
        )
    }

    if (!group.groupName) {
        return (<div>
            <TitlePage icon="fa-solid fa-circle-exclamation"
                       leftClass="col-10"
                       rightClass="col-2"
                       title={
                           <FormattedMessage id="group-details.not-found"/>
                       }
            />
            <div className="alert alert-danger" role="alert">
                <FormattedMessage id="group-details.not-found.details"/>
            </div>
            <MonkeyNotFound/>
        </div>)
    }

    if (loading) {
        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8"/>
                    <title>SquadDisk | {group.groupName}</title>
                    <link rel="icon" href={getGroupPhotoUrl(group)}/>
                </Helmet>
                <TitlePage icon=""
                           leftClass="col-10"
                           rightClass="col-2"
                           title={
                               <div className="d-flex flex-row align-items-center">
                                   <img style={{height: '3rem'}} className="image-border"
                                        src={getGroupPhotoUrl(group)}/>
                                   <span className="ps-2">
                               {group.groupName}
                               </span>
                               </div>
                           }/>
                <div className="d-flex flex-row justify-content-center">
                    <Spinner/>
                </div>
            </div>
        )
    }

    function askedToJoin() {
        return userGroups?.askedGroups?.some(x => x === group.id);
    }

    function hasBeenInvited() {
        return userGroups?.groupInvites?.some(x => x === group.id);
    }

    async function joinGroup(group, e, invited) {
        if (e) {
            e.preventDefault();
        }

        setLoading(true);
        const joinGroupFunction = functions.httpsCallable("joinGroup");
        const res = await joinGroupFunction({groupId: group.id});
        if (res.data.error) {
            toast.error(intl.formatMessage({id: "groups.group-limit-reached"}));
            setLoading(false);
            getGroupContainerWidth();
            return false;
        }
        if (group.privacy === GROUP_PUBLIC || invited) {
            group = res.data;
            dispatch(groups.actions.addNewGroup(group));
            dispatch(groups.actions.updateSearchedGroup(group))
            if (e) {
                loadGroup();
            }
        } else {
            dispatch(groups.actions.askedNewGroup(group));
            setLoading(false);
        }
        return true;
    }

    async function acceptJoinGroup(group, uid, accept) {
        setLoading(true);
        if (accept) {
            if (await joinGroup(group, null, true)) {
                dispatch(groups.actions.deleteInvite(group));
                loadGroup();
            }
        } else {
            const deleteInvitation = functions.httpsCallable('deleteGroupInvitation');
            const res = await deleteInvitation({groupId: group.id});
            dispatch(groups.actions.deleteInvite(group));
            navigate('/groups');
        }
    }

    const joinedGroup = () => {
        return userGroups?.groups.some(x => x.id === group.id);
    }

    if (showingSummary || (!joinedGroup() && group.privacy !== GROUP_PUBLIC && !loadingLeave)) {
        return (<div>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>SquadDisk | {group.groupName}</title>
                <link rel="icon" href={getGroupPhotoUrl(group)}/>
            </Helmet>
            <TitlePage icon=""
                       leftClass="col-10"
                       rightClass="col-2"
                       title={
                           <div className="d-flex flex-row align-items-center">
                               <img style={{height: '3rem'}} className="image-border" src={getGroupPhotoUrl(group)}/>
                               <span className="ps-2">
                               {group.groupName}
                               </span>
                           </div>
                       }/>
            <div className="d-flex flex-row flex-wrap justify-content-center">
                <div className="col-12 d-flex justify-content-center mb-1 mt-3"
                     style={{fontSize: "larger", fontWeight: "bolder"}}>
                    {group.privacy === GROUP_PRIVATE &&
                        <div>
                            <i className="fa-solid fa-lock me-1"></i>
                            <FormattedMessage id="group-details.group-private"/>
                            <i className="fa-solid fa-lock ms-1"></i>
                        </div>}
                    {group.privacy === GROUP_HIDDEN &&
                        <div>
                            <i className="fa-solid fa-eye-slash me-1"></i>
                            <FormattedMessage id="group-details.group-hidden"/>
                            <i className="fa-solid fa-eye-slash ms-1"></i>
                        </div>}
                </div>
                <div className="col-12 d-flex justify-content-center mb-4" style={{fontSize: "small"}}>
                    <FormattedMessage id="group-details.group-private.details"/>
                    {group.privacy === GROUP_PRIVATE &&
                        <FormattedMessage
                            id="group-details.group-private.info"/>}
                    {group.privacy === GROUP_HIDDEN &&
                        <FormattedMessage
                            id="group-details.group-hidden.info"/>}
                </div>
                {group.privacy === GROUP_PRIVATE && auth.currentUser && askedToJoin() && !hasBeenInvited() &&
                    <div>
                        <i className="fa-solid fa-lock"></i> <FormattedMessage id="groups.already-asked"/>
                    </div>}
                {group.privacy === GROUP_PRIVATE && !askedToJoin() && auth.currentUser && !hasBeenInvited() &&
                    <button className="btn btn-lg mt-4 btn-outline-secondary" onClick={(e) => {
                        joinGroup(group, e);
                    }}>
                        <i className="fa-solid fa-lock"></i> <FormattedMessage id="groups.ask-to-join"/>
                    </button>}
                {!auth.currentUser &&
                    <ButtonMenu text={intl.formatMessage({id: "users.login.log-in"})}
                                classIcon="fa-solid fa-right-to-bracket"
                                verified={true} className="mb-4" onClick={() => loginHome.current.openModal()}
                                forceBig={true}/>}
                {hasBeenInvited() &&
                    <div className="mt-4">
                        <hr/>
                        <div>
                            <FormattedMessage id="group-details.invite-info"/>
                        </div>
                        <div className="d-flex flex-row m-0 p-0 justify-content-center">
                            <button className="btn btn-lg mt-4 col-sm-8 me-2 btn-outline-success" onClick={(e) => {
                                acceptJoinGroup(group, auth.currentUser.uid, true);
                            }}><FormattedMessage id="groups.join-group"/><i className="fa-solid fa-check ms-2"></i>
                            </button>
                            <button className="btn btn-lg col-sm-8 mt-4 ms-2 btn-outline-danger" onClick={(e) => {
                                acceptJoinGroup(group, auth.currentUser.uid, false);
                            }}><FormattedMessage id="groups.reject-join-group"/><i
                                className="fa-solid fa-xmark ms-2"></i>
                            </button>
                        </div>
                    </div>
                }
            </div>
            <LoginHome ref={loginHome}/>

        </div>)
    }

    async function openMenu() {
        //recuperar las peticiones para unirse
        if (group.privacy === GROUP_PRIVATE) {
            const getJoinPetitions = functions.httpsCallable('getJoinPetitions');
            getJoinPetitions({groupId: group.id}).then(res => {
                setAskedUsers(res.data.askedUsers);
            })
        }
    }

    const hasRightAcceptUsers = () => {
        return group.privacy === GROUP_PRIVATE && checkUserGroupRole(userRoles, roles, ACCEPT_USERS, group);
    }


    const hasRightModifyGroupInfo = () => {
        return checkUserGroupRole(userRoles, roles, MODIFY_INFO, group);
    }

    const hasRightTagOwnFiles = () => {
        return checkUserGroupRole(userRoles, roles, TAG_OWN_FILES, group)
    }

    const hasRightDeleteFiles = () => {
        return checkUserGroupRole(userRoles, roles, DELETE_POSTS, group)
    }

    const hasRightManageTags = () => {
        return checkUserGroupRole(userRoles, roles, MANAGE_TAGS, group);
    }

    const canModifyThisPost = post => {
        return (post.file.uid === auth.currentUser?.uid && hasRightTagOwnFiles()) || hasRightManageTags();
    }

    const canDeleteThisPost = post => {
        return post.file.uid === auth.currentUser?.uid || hasRightDeleteFiles();
    }

    const popoverTags = (
        <Popover id="popover-tags">
            <Popover.Body>
                <InputSaveEdit inputValue={tagSearch} showLabel={false} onSave={value => setTagSearch(value)}
                               label={intl.formatMessage({id: "app.search"})} alwaysEditing={true}
                               id="searchTagInput" required={false}></InputSaveEdit>
                <ul className="list-group mt-1" style={{maxHeight: "160px", overflowY: "auto"}}>
                    {tags?.filter(x => normalize(x.tag).includes(normalize(tagSearch))).map(tag =>
                        <div key={tag.id} onClick={() => addTagToPost(selectedPost, tag)}
                             style={{cursor: "pointer", userSelect: "none"}}
                             className="list-group-item list-group-item-action d-flex flex-row justify-content-between">
                            {tag.tag}
                            <span>
                            {selectedPost?.tags.includes(tag.id) ?
                                <i className="fa-solid fa-circle-xmark ms-2 text-danger"></i> :
                                <i className="fa-solid fa-circle-plus ms-2"></i>}
                            </span>
                        </div>)}
                </ul>
            </Popover.Body>
        </Popover>
    );

    const checkSearch = (file) => {
        if (selectedTag) {
            if (!file.tags.includes(selectedTag)) {
                return false;
            }
        }
        return normalize(file.title).includes(normalize(textSearch)) || normalize(file.description).includes(normalize(textSearch)) ||
            file.tagList?.some(x => normalize(x.tag).includes(normalize(textSearch)));
    }

    setTimeout(() => setStartLoad(false), 200);

    return (
        <div id="groupDetailsContainer" className=" position-relative " style={{marginTop: "10rem"}}>

            <Helmet>
                <meta charSet="utf-8"/>
                <title>SquadDisk | {group.groupName}</title>
                <link rel="icon" href={getGroupPhotoUrl(group)}/>
            </Helmet>


            {group.privacy === GROUP_PUBLIC && !joinedGroup() && auth.currentUser &&
                <div className="d-flex justify-content-center mt-2">
                    <button className="btn btn-lg btn-outline-secondary" onClick={(e) => {
                        joinGroup(group, e);
                    }}>
                        <i className="fa-solid fa-lock-open"></i> <FormattedMessage id="groups.join-group"/>&nbsp;
                        <FormattedMessage id="group-invites.group"/>
                    </button>
                </div>}

            {!auth.currentUser &&
                <div className="d-flex flex-row flex-wrap justify-content-center">
                    <ButtonMenu text={intl.formatMessage({id: "users.login.log-in"})}
                                classIcon="fa-solid fa-right-to-bracket"
                                verified={true} className="mb-1" onClick={() => loginHome.current.openModal()}
                                forceBig={true}/>
                </div>}

            <CustomModal modalName="menuGroupModal" closeButtonRef={closeMenuModal} content={
                <GroupMenu group={group} setGroup={setGroup} askedUsers={askedUsers} setAskedUsers={setAskedUsers}
                           userRoles={userRoles} roles={roles} setRoles={setRoles} loadingLeave={loadingLeave}
                           setLoadingLeave={setLoadingLeave} tags={tags} setTags={setTags}
                           closeModal={() => {
                               closeMenuModal.current.click();
                           }}/>
            }/>

            {hasRightModifyGroupInfo() && <div className="collapse" id="collapseExample">
                <Fragment>
                    <GroupForm inputGroup={group} setInputGroup={setGroup} onSave={() => {
                        setEditing(false);
                        saveButtonForm.current.click();
                    }}/>
                    <hr className="mb-2"/>
                </Fragment>
            </div>}

            {files?.length > 0 &&
                <div id="postsContainer">
                    {files.filter(x => checkSearch(x)).slice(0, postsPerPage * postsPage).map(file => {
                        return <GroupPost key={file.file.id + file.dateTimestamp} post={file} group={group} tags={tags}
                                          canDeletePost={canDeleteThisPost(file)}
                                          tagsContainer={canModifyThisPost(file) &&
                                              <div>
                                                  <OverlayTrigger
                                                      trigger="click" // You can change this to "hover", "focus", or any combination of them
                                                      placement="bottom" // Change this to the desired placement
                                                      overlay={popoverTags}
                                                      show={popoverOpen && activeButton === file.fileRef && !file.loadingAddTag}
                                                      rootClose
                                                      onHide={closePopover}>
                                                      <button disabled={tags?.length < 1}
                                                              onClick={e => openPopover(file, e)} id={file.fileRef}
                                                              style={{background: "none", border: "none"}}>
                                                          <i id={file.fileRef}
                                                             className={"fa-solid " + (!file.loadingAddTag ? "fa-tags" : "fa-spinner fa-spin")}></i>
                                                      </button>
                                                  </OverlayTrigger>
                                              </div>}/>
                    })}
                </div>}
            <div id="visor" className="mb-4"></div>

            {!startLoad && <div id="fixed-navbar" style={{
                top: hideOptions ? (isMobileDevice() ? "-5.4rem" : "-7rem") : "1.5rem",
                transitionDuration: '0.5s', position: 'fixed',
                width: (navWidth ? navWidth : getGroupContainerWidth()) + 'px', // Establece el ancho al 100% del div contenedor
                zIndex: '100'
            }}>

                <div style={{
                    position: "absolute", top: "-2rem",
                    backgroundColor: (darkMode ? "#212529" : "white"),
                    height: (isMobileDevice() ? "7.1rem" : "8.7rem"), width: "100%", zIndex: "-1"
                }}>

                </div>
                <div>
                    <TitlePage icon=""
                               disableScroll={true}
                               leftClass="col-10"
                               rightClass="col-2"
                               title={
                                   <div className="d-flex flex-row align-items-center">
                                       <img style={{height: '3rem'}} className="image-border"
                                            src={getGroupPhotoUrl(group)}/>
                                       <span className="ps-2">
                               {group.groupName}
                               </span>
                                   </div>
                               }
                               rightOptions={
                                   <div className="d-flex flex-row align-items-center">
                                       {hasRightModifyGroupInfo() && !editing &&
                                           <button
                                               title={intl.formatMessage({id: "group-details.group-menu.group-info-edit"})}
                                               className="btn btn-outline-secondary ms-2 position-relative"
                                               type="button"
                                               onClick={() => setEditing(true)}
                                               data-bs-toggle="collapse"
                                               data-bs-target="#collapseExample"
                                               aria-expanded="false" aria-controls="collapseExample">
                                               <i className="fa-solid fa-pencil"></i>
                                           </button>
                                       }
                                       {hasRightModifyGroupInfo() && editing &&
                                           <button ref={saveButtonForm}
                                                   title={intl.formatMessage({id: "app.save-changes"})}
                                                   className="btn btn-outline-secondary ms-2 position-relative"
                                                   type="button"
                                                   onClick={() => setEditing(false)}
                                                   data-bs-toggle="collapse"
                                                   data-bs-target="#collapseExample"
                                                   aria-expanded="false"
                                                   aria-controls="collapseExample">
                                               <i className="fa-solid fa-floppy-disk"></i>
                                           </button>
                                       }
                                       {joinedGroup() && <button onClick={openMenu} type="button"
                                                                 title={intl.formatMessage({id: "group-details.group-menu"})}
                                                                 className="btn btn-outline-secondary ms-2 position-relative"
                                                                 data-bs-toggle="modal"
                                                                 data-bs-target="#menuGroupModal">
                                           <i className="fa-solid fa-bars"></i>
                                           {hasRightAcceptUsers() && askedUsers?.length > 0 && <span
                                               className="position-absolute top-0 start-0 translate-middle badge rounded-pill bg-danger">
                                       {askedUsers.length ?? 0}
                                  </span>}
                                       </button>}
                                   </div>
                               }/>
                    <TitlePage
                        disableScroll={true}
                        leftClass="col-12" rightClass="col-0"
                        title={
                            <div className="d-flex flex-row align-items-center">
                                <i className="fa-solid fa-magnifying-glass"></i>
                                <input
                                    className="link-body-emphasis col-12 pe-5 ps-2 form-control border-0"
                                    value={textSearch}
                                    style={{
                                        border: "none",
                                        boxShadow: "none",
                                        background: "none",
                                        zIndex: 1
                                    }}
                                    maxLength="20"
                                    placeholder={intl.formatMessage({id: "group-details.search-files"})}
                                    onChange={(e) => {
                                        setTextSearch(e.target.value);
                                        setPostsPage(1);
                                    }}/>
                            </div>
                        }
                    />

                </div>
                <div className="d-flex flex-row pb-1" style={{overflowX: "auto"}}>
                    {tags && [...tags].sort((a, b) => a.totalFiles - b.totalFiles).map(tag => {
                        if (!tag) {
                            return;
                        }
                        return (
                            <span key={tag.id}
                                  className={"badge rounded-pill me-1 d-flex flex-row align-items-center " + ((darkMode ^ (tag.id === selectedTag)) ? "text-light" : "text-dark")}
                                  onClick={() => {
                                      if (selectedTag === tag.id) {
                                          setSelectedTag(null)
                                      } else {
                                          setSelectedTag(tag.id)
                                      }
                                      setPostsPage(1);
                                  }}
                                  style={{
                                      userSelect: "none",
                                      cursor: "pointer",
                                      backgroundColor: ((darkMode ^ (tag.id === selectedTag)) ? "dimgray" : "whitesmoke")
                                  }}>
                             <div style={{
                                 width: "14px",
                                 height: "14px",
                                 borderRadius: "40px",
                                 backgroundColor: tag?.color
                             }}
                                  className=" me-1"></div>
                                {tag?.tag}
                        </span>)
                    })}
                </div>
            </div>}
            <LoginHome ref={loginHome}/>

        </div>


    )

}

export default GroupDetails;
